function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "33",
  height: "32",
  viewBox: "0 0 33 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.475 12.938h11a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.118 18.831C.366 12.317 3.385 4.793 9.861 2.024c6.476-2.768 13.957.268 16.71 6.782a12.874 12.874 0 01-2.71 14.072l6.637 7.12a1.082 1.082 0 01-.05 1.523 1.067 1.067 0 01-1.513-.049l-6.713-7.202c-.733.523-1.533.975-2.394 1.343-6.476 2.768-13.958-.268-16.71-6.782zm7.58-14.824C5.311 6.31 2.8 12.57 5.09 17.988c2.29 5.42 8.513 7.945 13.901 5.643 5.388-2.303 7.899-8.563 5.61-13.982-2.29-5.42-8.514-7.945-13.902-5.642z",
  fill: "currentColor"
})));